import { createSocialHeadMeta } from "~/lib/social-head";
import { DEFAULT_SOCIAL_METADATA } from "~/lib/social-metadata";
import type { DocumentMetadata } from "./document-metadata";

export function toOpenGraphLocale(locale: string): string {
  return (
    { en: "en_US", de: "de_DE", tr: "tr_TR" }[locale] ??
    locale.replace("-", "_")
  );
}

export function createDocumentHead(
  metadata: DocumentMetadata | null | undefined,
  fallbackLocale = "en",
) {
  return {
    links: [
      ...(metadata?.canonicalHref
        ? [{ href: metadata.canonicalHref, rel: "canonical" }]
        : []),
      ...(metadata?.iconPreloadHref
        ? [
            {
              href: new URL(metadata.iconPreloadHref).origin,
              rel: "preconnect",
            },
            {
              href: metadata.iconPreloadHref,
              rel: "preload",
              as: "image",
              fetchPriority: "high" as const,
            },
          ]
        : []),
    ],
    meta: [
      ...createSocialHeadMeta(
        metadata?.socialMetadata ?? DEFAULT_SOCIAL_METADATA,
        metadata?.socialImageHref,
      ),
      ...(metadata?.canonicalHref
        ? [{ content: metadata.canonicalHref, property: "og:url" }]
        : []),
      {
        content: toOpenGraphLocale(metadata?.languageTag ?? fallbackLocale),
        property: "og:locale",
      },
    ],
  };
}
